// Relocated into @vestra/agent-sdk (contract/ability-hooks.ts, ring 4b-5).
// Named re-exports keep the @bash/shared/abilities surface byte-identical without
// leaking the whole SDK into this subpath.
export type { AbilityHookEvent, AbilityHookCommand, AbilityHookGroup, AbilityHookConfig, AbilityPromptHook } from '@vestra/agent-sdk';
export { ABILITY_HOOK_EVENTS, isAbilityHookEvent, parseAbilityHooks, abilityHookScriptRefs } from '@vestra/agent-sdk';
